import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextareaAutosize, Typography } from "@mui/material";
import { useAppDispatch } from "../../../redux/hooks";
import { addSnackbar } from "../../../redux/snackbars/snackbars.slice";
import { t } from "../../../i18n/translates";
import { ProjectInterface } from "../types";

export const GreetingEditorDialog = ({
    project,
    open,
    onClose,
    applyGreeting,
    currentGreeting,
    catchError,
}: {
    project: ProjectInterface;
    open: boolean;
    onClose: () => void;
    currentGreeting: string;
    applyGreeting: (g: string) => Promise<void>;
    catchError: (e: Error) => void;
}) => {
    const dispatch = useAppDispatch();
    const [greeting, setGreeting] = useState(currentGreeting);

    const uploadGreeting = () => {
        applyGreeting(greeting)
            .then(() => {
                dispatch(
                    addSnackbar({
                        color: "success",
                        title: t("common.saved"),
                    })
                );
                onClose();
            })
            .catch((err) => {
                catchError(err);
            });
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Edit Greeting</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    <TextareaAutosize
                        minRows={10}
                        style={{ width: "100%", maxWidth: "100%" }}
                        value={greeting}
                        onChange={(e) => setGreeting(e.target.value)}
                        placeholder="Type your greeting here..."
                    />
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => uploadGreeting()}
                    disabled={project.isProtected}
                >
                    Upload Greeting
                </Button>
            </DialogActions>
        </Dialog>
    );
};
